import { useEffect } from 'react';

import useHistory from 'routing/useHistory';

import CrowdStrikeRoutes from './common/Routes';

type Props = { url: string };

// https://stackoverflow.com/questions/52912238/render-methods-should-be-a-pure-function-of-props-and-state

const CrowdStrikeInputConfiguration: React.FC<Props> = (
) => {
  const history = useHistory();

  useEffect(() => {
    const indexUrl = CrowdStrikeRoutes.INTEGRATIONS.CrowdStrike.ACTIVITYAPI.index;
    history.push(indexUrl);
  }, [history]);

  return null;
};

export default CrowdStrikeInputConfiguration;
